import EmptyComponent from "../../../../../../Components/Empty"
import Spinner from "../../../../../../Components/Spinner"
import DisputeCard from "../DisputeCard/DisputeCard"

import "./DisputesList.less"

// Grid (card) view for the disputes list. Mirrors the Alerts AlertsList: a
// responsive CSS grid of cards, with the same empty/loading states.
const DisputesList = ({ results, fetching, EmptyState, ...cardProps }) => {
  const rows = Array.isArray(results) ? results : Array.from(results || [])

  if (fetching && rows.length === 0) {
    return (
      <div className="disputes-cards-list_state">
        <Spinner />
      </div>
    )
  }
  if (rows.length === 0) {
    // Same branching as the table: "no results, clear filters" vs "no disputes".
    return (
      <div className="disputes-cards-list_state">
        {EmptyState ? <EmptyState /> : <EmptyComponent type="no_disputes" />}
      </div>
    )
  }

  return (
    <div className="disputes-cards-list">
      {rows.map((d) => (
        <DisputeCard key={d.id} dispute={d} {...cardProps} />
      ))}
    </div>
  )
}

export default DisputesList
